module.exports = __webpack_public_path__ + "img/icon-station-line-tick.537ad5e8.svg";